module.exports = __webpack_public_path__ + "img/annual.d21c127b.jpg";